module.exports = __webpack_public_path__ + "static/media/toyota_gt86_red.952ec162.jpg";